export default __webpack_public_path__ + "static/media/chart.822aedd0.svg";